import { render, staticRenderFns } from "./SelectObjectMultiLocPlacesInput.vue?vue&type=template&id=2a9e0d54"
import script from "./SelectObjectMultiLocPlacesInput.vue?vue&type=script&lang=js"
export * from "./SelectObjectMultiLocPlacesInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports